export const marketplaceAddress = "0x6D89e1be18912D3F212e16A4E40AfaEd4eaF5a08"


// 207e0c12.0ca654f5c03a4be18a3185ea63c31f81   API FOR UPLOAD TO LIGHTHOUSE